import { createContext, useState } from "react";

export const OTPVerifyContext = createContext();

const OTPVerifyProvider = ({ children }) => {
  const [verifyData, setVerifyData] = useState({});
  const collectData = (data) => {
    setVerifyData(data);
  };

  return (
    <OTPVerifyContext.Provider
      value={{
        verifyData,
        collectData,
      }}
    >
      {children}
    </OTPVerifyContext.Provider>
  );
};
export default OTPVerifyProvider;
